import React from "react";

export default [
  <option key={"null"} value="" disabled="disabled">
    Select A State
  </option>,
  <option key={"ak"} value="AK">
    Alaska
  </option>,
  <option key={"al"} value="AL">
    Alabama
  </option>,
  <option key={"az"} value="AZ">
    Arizona
  </option>,
  <option key={"ar"} value="AR">
    Arkansas
  </option>,
  <option key={"ca"} value="CA">
    California
  </option>,
  <option key={"co"} value="CO">
    Colorado
  </option>,
  <option key={"ct"} value="CT">
    Connecticut
  </option>,
  <option key={"de"} value="DE">
    Delaware
  </option>,
  <option key={"dc"} value="DC">
    District Of Columbia
  </option>,
  <option key={"fl"} value="FL">
    Florida
  </option>,
  <option key={"ga"} value="GA">
    Georgia
  </option>,
  <option key={"hi"} value="HI">
    Hawaii
  </option>,
  <option key={"id"} value="ID">
    Idaho
  </option>,
  <option key={"il"} value="IL">
    Illinois
  </option>,
  <option key={"in"} value="IN">
    Indiana
  </option>,
  <option key={"ia"} value="IA">
    Iowa
  </option>,
  <option key={"ks"} value="KS">
    Kansas
  </option>,
  <option key={"ky"} value="KY">
    Kentucky
  </option>,
  <option key={"la"} value="LA">
    Louisiana
  </option>,
  <option key={"me"} value="ME">
    Maine
  </option>,
  <option key={"md"} value="MD">
    Maryland
  </option>,
  <option key={"ma"} value="MA">
    Massachusetts
  </option>,
  <option key={"mi"} value="MI">
    Michigan
  </option>,
  <option key={"mn"} value="MN">
    Minnesota
  </option>,
  <option key={"ms"} value="MS">
    Mississippi
  </option>,
  <option key={"mo"} value="MO">
    Missouri
  </option>,
  <option key={"mt"} value="MT">
    Montana
  </option>,
  <option key={"ne"} value="NE">
    Nebraska
  </option>,
  <option key={"nv"} value="NV">
    Nevada
  </option>,
  <option key={"nh"} value="NH">
    New Hampshire
  </option>,
  <option key={"nj"} value="NJ">
    New Jersey
  </option>,
  <option key={"nm"} value="NM">
    New Mexico
  </option>,
  <option key={"ny"} value="NY">
    New York
  </option>,
  <option key={"nc"} value="NC">
    North Carolina
  </option>,
  <option key={"nd"} value="ND">
    North Dakota
  </option>,
  <option key={"oh"} value="OH">
    Ohio
  </option>,
  <option key={"ok"} value="OK">
    Oklahoma
  </option>,
  <option key={"or"} value="OR">
    Oregon
  </option>,
  <option key={"pa"} value="PA">
    Pennsylvania
  </option>,
  <option key={"ri"} value="RI">
    Rhode Island
  </option>,
  <option key={"sc"} value="SC">
    South Carolina
  </option>,
  <option key={"sd"} value="SD">
    South Dakota
  </option>,
  <option key={"tn"} value="TN">
    Tennessee
  </option>,
  <option key={"tx"} value="TX">
    Texas
  </option>,
  <option key={"ut"} value="UT">
    Utah
  </option>,
  <option key={"vt"} value="VT">
    Vermont
  </option>,
  <option key={"va"} value="VA">
    Virginia
  </option>,
  <option key={"wa"} value="WA">
    Washington
  </option>,
  <option key={"wv"} value="WV">
    West Virginia
  </option>,
  <option key={"wi"} value="WI">
    Wisconsin
  </option>,
  <option key={"wy"} value="WY">
    Wyoming
  </option>,
  <option key={"ae"} value="AE">
    AE–Armed Forces Europe, Middle East, Africa and Canada
  </option>,
  <option key={"aa"} value="AA">
    AA–Armed Forces Americas
  </option>,
  <option key={"ap"} value="AP">
    AP–Armed Forces Pacific
  </option>,
];
